export default {
  toggleLoading(state, isLoading) {
    state.loading = isLoading;
  },
  setStatusRecon(state, statusRecon) {
    state.content = statusRecon;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-status-recon/store/mutations.js